/** `/charge-record/exportStatuses/`: export/download statuses. */
const EXPORT_STATUSES_RESPONSE = { data: [], totalElements: 0 };

export { EXPORT_STATUSES_RESPONSE };
